import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { consentHelper } from '../../../../helpers'
import { PREFERENCES_EVENT } from '../../../../helpers/consent.helper'

import css from './CookieBanner.module.scss'

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(
    consentHelper.getConsentStatus() === 'pending'
  )

  // Consenso già dato in una visita precedente: Analytics riparte
  useEffect(() => {
    if (consentHelper.getConsentStatus() === 'accepted') {
      consentHelper.startAnalytics()
    }
  }, [])

  // "Preferenze cookie" nel footer riapre il banner
  useEffect(() => {
    const open = () => setShowBanner(true)
    window.addEventListener(PREFERENCES_EVENT, open)
    return () => window.removeEventListener(PREFERENCES_EVENT, open)
  }, [])

  const handleAccept = () => {
    consentHelper.setConsent(true)
    setShowBanner(false)
    consentHelper.startAnalytics()
  }

  const handleReject = () => {
    const previous = consentHelper.getConsentStatus()
    consentHelper.setConsent(false)
    setShowBanner(false)
    if (previous === 'accepted') consentHelper.stopAnalytics()
  }

  if (!showBanner) return null

  return (
    <div className={css.CookieBanner}>
      <p>
        Usiamo Google Analytics solo se acconsenti, per capire in forma
        aggregata come viene usato il sito. Senza consenso non raccogliamo dati
        statistici. Puoi cambiare scelta quando vuoi da «Preferenze cookie», in
        fondo alla pagina.
        <Link to='/privacy-policy'>
          Per saperne di più
        </Link>
        .
      </p>
      <ul className={css.UlCookieButtons}>
        <li>
          <button onClick={handleReject} className='btn-secondary'>
            Rifiuta
          </button>
        </li>
        <li>
          <button onClick={handleAccept} className='btn-primary'>
            Accetta
          </button>
        </li>
      </ul>
    </div>
  )
}

export default CookieBanner
